// src/app/auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
 
 
  constructor(private authService: AuthService, private router: Router,private route: ActivatedRoute) {}

  // Implement the canActivate method to check if the user is authenticated
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    if (!this.authService.isAuthenticated()){
      return true
     
      }else{
        this.router.navigate(['/home']);
        return false;
      }
     // User is authenticated
   


}
}